export const PANORAMA_LOGO_SRC = '/cropwise-planting-logo.svg';

export const PANORAMA_LOGO_ALT = 'Cropwise Planting';

export const HOME_PATH = '/';
